import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeartBroken = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 11.7L17 17L22 20L20 24",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25 9C24.0095 9.00777 23.036 9.2579 22.1644 9.72855C21.2929 10.1992 20.5498 10.876 20 11.7C19.2911 10.6222 18.2534 9.80198 17.0411 9.36114C15.8287 8.92029 14.5065 8.88239 13.2709 9.25307C12.0353 9.62375 10.9523 10.3832 10.1829 11.4186C9.41341 12.454 8.99857 13.71 9 15C9 21 20 30 20 30C20 30 31 21 31 15C30.9953 13.4102 30.3616 11.8868 29.2374 10.7626C28.1132 9.63841 26.5898 9.00475 25 9V9Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})]
});
const ForwardRef = forwardRef(SvgHeartBroken);
export default ForwardRef;
